export const knowledgeConstants = {
    KNOWLEDGE_LATEST_QUIZZES_REQUEST: "KNOWLEDGE_LATEST_QUIZZES_REQUEST",
    KNOWLEDGE_LATEST_QUIZZES_COMPLETE: "KNOWLEDGE_LATEST_QUIZZES_COMPLETE",

    KNOWLEDGE_DASHBOARD_REQUEST: "KNOWLEDGE_DASHBOARD_REQUEST",
    KNOWLEDGE_DASHBOARD_COMPLETE: "KNOWLEDGE_DASHBOARD_COMPLETE",

    KNOWLEDGE_PARTICIPANT_QUIZZES_REQUEST:
        "KNOWLEDGE_PARTICIPANT_QUIZZES_REQUEST",
    KNOWLEDGE_PARTICIPANT_QUIZZES_COMPLETE:
        "KNOWLEDGE_PARTICIPANT_QUIZZES_COMPLETE",

    KNOWLEDGE_QUIZZE_DETAILS_REQUEST: "KNOWLEDGE_QUIZZE_DETAILS_REQUEST",
    KNOWLEDGE_QUIZZE_DETAILS_COMPLETE: "KNOWLEDGE_QUIZZE_DETAILS_COMPLETE",

    KNOWLEDGE_ANSWER_QUESTION_REQUEST: "KNOWLEDGE_ANSWER_QUESTION_REQUEST",
    KNOWLEDGE_ANSWER_QUESTION_COMPLETE: "KNOWLEDGE_ANSWER_QUESTION_COMPLETE",

    KNOWLEDGE_ENROL_QUIZZE_REQUEST: "KNOWLEDGE_ENROL_QUIZZE_REQUEST",
    KNOWLEDGE_ENROL_QUIZZE_COMPLETE: "KNOWLEDGE_ENROL_QUIZZE_COMPLETE",

    KNOWLEDGE_QUESTION_RESULT_REQUEST: "KNOWLEDGE_QUESTION_RESULT_REQUEST",
    KNOWLEDGE_QUESTION_RESULT_COMPLETE: "KNOWLEDGE_QUESTION_RESULT_COMPLETE",
};

export const quizState = {
    DEFAULT: 1,
    FEATURED: 2,
    NEW: 3,
};

export const participationState = {
    NOT_STARTED: 1,
    IN_PROGRESS: 2,
    SUCCESS: 4,
    RETAKE: 5,
    UNSUCCESSFUL: 6,
};

export const questionType = {
    MULTIPLE_CHOICE_QUESTION: 1,
    MULTIPLE_PICTURE_QUESTION: 2,
    PICTURE_QUESTION: 3,
    RANGE_QUESTION: 4,
    RATING_QUESTION: 5,
};
